import { render, staticRenderFns } from "./ModalListDetail.vue?vue&type=template&id=97e15f9c&scoped=true"
import script from "./ModalListDetail.vue?vue&type=script&lang=js"
export * from "./ModalListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e15f9c",
  null
  
)

export default component.exports